import { useState } from 'react';
import { Minus, Plus } from 'lucide-react';

const faqData = [
  {
    title: 'Who is eligible for a "Pay SmallSmall" plan?',
    content:
      'To be eligible, you must be a resident of Lagos, Nigeria, with a verifiable source of income and a valid form of identification. Our system is designed to provide quick approvals for most applicants who meet these basic criteria.',
  },
  {
    title: 'Is there any interest or hidden fees with this plan?',
    content:
      "No, we believe in complete transparency. Unlike traditional credit plans, our 'Pay SmallSmall' plan has no interest rates. All fees, including a nominal service fee, are clearly stated and included in your total payment plan before you make a commitment. You'll never be surprised by a hidden cost.",
  },
  {
    title: 'What documents will I need to apply?',
    content:
      'Our verification process is seamless and secure. You will need to provide a valid government-issued ID, proof of address, and proof of income (such as a recent bank statement or a payslip).',
  },
  {
    title: 'How long does the approval process take?',
    content:
      'Our automated system provides an initial response in 24hrs or less. In most cases, you can get approved and complete your purchase on the same day.',
  },
  {
    title: 'How do I make my payments?',
    content:
      'All payments are managed securely within the SmallSmall app. You can make payments via bank transfer, debit card, or any of our other convenient payment methods. We also offer payment reminders to help you stay on track.',
  },
  {
    title: 'What happens if I miss a payment?',
    content:
      "We understand that life happens. If you anticipate missing a payment, please contact our support team immediately. We'll work with you to find a solution. While late payments may incur a small fee, our goal is to help you succeed, not penalize you.",
  },
  {
    title: 'Can I pay off my plan early?',
    content:
      'Yes, you can! We encourage it. There are no penalties or additional fees for paying off your balance before the scheduled end date. You can simply make an early lump sum payment through the app.',
  },
];

function Accordion({ children }) {
  const [activeIndex, setActiveIndex] = useState(null);

  function handleClick(index) {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  }

  return (
    <>
      <div className="md:w-[60%] w-full  mx-auto bg-white rounded-lg divide-y p-6 mb-40">
        {children}
        {faqData.map((item, index) => (
          <AccordionItem
            key={index}
            title={item.title}
            content={item.content}
            isOpen={activeIndex === index}
            onClick={() => handleClick(index)}
          />
        ))}
      </div>
    </>
  );
}

function AccordionItem({ title, content, isOpen, onClick }) {
  return (
    <div className="border-b">
      <button
        onClick={onClick}
        className="w-full flex justify-between items-center py-4 text-left"
      >
        <span className="font-semibold">{title}</span>

        {isOpen ? <Minus /> : <Plus />}
      </button>
      {isOpen && (
        <div className="pb-4 text-sm text-gray-600">
          {typeof content === 'string' ? <p>{content}</p> : content}
        </div>
      )}
    </div>
  );
}

export default Accordion;
